module.exports = __webpack_public_path__ + "static/img/qingye.3c3e0c4f.png";